<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-8">
        <div class="card-group mb-0">
          <div class="card p-4 position-relative">
            <div class="card-body">
              <form (ngSubmit)="submit()" [formGroup]="form">
                <h1>Reset password</h1>
                @if (showRedirectMessage) {
                  <p class="alert alert-info">
                    A change password email was sent to the entered email
                    address. Follow the instructions in the email to set your
                    new password.
                  </p>
                }
                <p class="text-muted">Please enter a new password.</p>
                @if (form.errors) {
                  <div class="alert alert-danger" role="alert">
                    <i class="fa fa-lg fa-warning">&nbsp;</i
                    >{{ form.errors.global }}
                  </div>
                }
                <div class="input-group mb-3 mb-3">
                  <span class="input-group-addon input-group-text"
                    ><i class="icon-shield"></i
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    [class.is-invalid]="showFieldInvalid('code')"
                    placeholder="Code (e.g. ABCD1234)"
                    id="code"
                    name="code"
                    formControlName="code"
                    autocomplete="off" />
                  @if (showFieldInvalid('code')) {
                    <div class="invalid-feedback">
                      Please enter the password code listed in the received
                      email.
                    </div>
                  }
                </div>

                <div class="input-group">
                  <span class="input-group-addon input-group-text"
                    ><i class="icon-lock"></i
                  ></span>
                  <input
                    [type]="isPasswordHidden ? 'password' : 'text'"
                    class="form-control"
                    placeholder="Password"
                    id="password"
                    name="password"
                    formControlName="password" />
                  <button
                    class="btn btn-outline-secondary text-dark"
                    type="button"
                    (click)="togglePasswordHideShow()"
                    (keydown.enter)="togglePasswordHideShow()"
                    tabindex="-1">
                    <i
                      class="fa fa-lg"
                      [ngClass]="
                        isPasswordHidden ? 'fa-eye' : 'fa-eye-slash'
                      "></i>
                  </button>
                </div>
                <div class="row mb-4">
                  <div class="col-12">
                    <small class="text-muted small-text">
                      {{
                        'Password needs to contain at least 8 characters and must contain an upper case character, a lower case character, a number, and a special character(!@#$%^&*(){}[]<>?|/)'
                      }}
                    </small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <button
                      type="button"
                      type="submit"
                      [disabled]="form.invalid"
                      class="btn btn-primary px-4">
                      Set password
                    </button>
                  </div>
                  <div class="col-6 text-end">
                    <button
                      type="button"
                      type="button"
                      class="btn btn-link px-0"
                      [routerLink]="['/login']">
                      To login
                    </button>
                  </div>
                </div>
              </form>
            </div>
            @if (loading) {
              <loader-line></loader-line>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
